var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'bg-' + _vm.color + ' hover:bg-' + _vm.color + '-lighter rounded text-white px-4 py-2 cursor-pointer inline-block',on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }